import { map, toPairs } from 'ramda';

export const useGetAllOptions = (optionsByName) => {
  // Convert grouped options to display format
  return map(
    ([optionName, tariffs]) => ({
      label: optionName,
      tariffs: tariffs,
      priceUnit: '€'
    }),
    toPairs(optionsByName)
  );
};
